<div class="border border-grey-light rounded mt-4 md:mt-5">
	<div class="relative flex flex-col">
		<div class="absolute z-1 top-0 left-1/2 transform -translate-y-1/2 -translate-x-1/2">
			<div class="bg-grey-light w-[80px] h-[80px] rounded-full border-white border-8" />
		</div>
		<div class="space-y-4 animate-pulse pb-4">
			<div class="h-8 bg-grey-light w-full" />
			<div class="px-4 space-y-2">
				<div class="flex justify-between">
					<div class="h-4 bg-grey-light rounded w-2/3" />
				</div>
			</div>
			<div class="px-4 space-y-2">
				<div class="h-3 bg-grey-light rounded" />
				<div class="h-3 bg-grey-light rounded w-5/6" />
				<div class="h-3 bg-grey-light rounded" />
			</div>
			<div class="px-4 space-y-2">
				<div class="flex justify-between">
					<div class="h-4 bg-grey-light rounded w-1/4" />
					<div class="h-4 bg-grey-light rounded w-1/4" />
					<div class="h-4 bg-grey-light rounded w-1/4" />
				</div>
			</div>
		</div>
	</div>
</div>
